export type Course = { id: string; name: string; enabled: boolean }
export type Board = { id: string; name: string; levels: string[] }
export type Level = { id: string; name: string }

export const fetchCourses = (): Promise<Course[]> => {
  return Promise.resolve([
    { id: "0", name: "Maths", enabled: true },
    ...Array.from([
      "English Language",
      "English Literature",
      "Physics",
      "Chemistry",
      "Biology",
      "French",
      "Spanish",
      "Geography",
      "History",
      "Religious Education",
      "Classical Civilisation",
      "Latin",
      "Greek",
      "Art",
      "Design & Technology",
      "Business Studies"
    ]).map((value, idx) => ({
      id: `${idx + 1}`,
      name: value,
      enabled: false
    }))
  ])
}

export const fetchBoards = (): Promise<Board[]> => {
  return Promise.resolve([
    { id: "0", name: "Edexcel", levels: ["Higher", "Foundation"] },
    { id: "1", name: "AQA", levels: ["Higher", "Foundation"] },
    { id: "2", name: "OCR", levels: ["Higher", "Foundation"] },
    { id: "3", name: "WJEC", levels: ["Higher", "Intermediate", "Foundation"] }
  ])
}

export const fetchLevels = (board: Board): Promise<Level[]> => {
  const arr = board.levels.map((val, idx) => {
    return { id: `${idx}`, name: val }
  })

  return Promise.resolve(arr)
}
